import type { UserProfile } from "@/lib/api-types"
import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export type User = UserProfile & {
	avatar?: string
}

interface AuthState {
	user: User | null
	isAuthenticated: boolean
	token: string | null
	refreshToken: string | null
}

interface AuthActions {
	login: (user: User, token: string, refreshToken: string) => void
	logout: () => void
	updateUser: (userData: Partial<User>) => void
	updateTokens: (token: string, refreshToken: string) => void
}

type AuthStore = AuthState & AuthActions

export const useAuthStore = create<AuthStore>()(
	persist(
		(set, get) => ({
			user: null,
			isAuthenticated: false,
			token: null,
			refreshToken: null,

			login: (user: User, token: string, refreshToken: string) => {
				set({
					user,
					token,
					refreshToken,
					isAuthenticated: true,
				})
			},

			logout: () => {
				set({
					user: null,
					token: null,
					refreshToken: null,
					isAuthenticated: false,
				})
			},

			updateUser: (userData: Partial<User>) => {
				const currentUser = get().user
				if (currentUser) {
					set({
						user: { ...currentUser, ...userData },
					})
				}
			},

			updateTokens: (token: string, refreshToken: string) => {
				set({
					token,
					refreshToken,
					isAuthenticated: true,
				})
			},
		}),
		{
			name: 'clothesweb-auth',
			partialize: (state) => ({
				user: state.user,
				token: state.token,
				refreshToken: state.refreshToken,
				isAuthenticated: state.isAuthenticated,
			}),
		},
	),
)
